import React from "react";

export const ErrorSvg = (props) => {
  const { width, height } = props;

  return (
    <svg
      width={width ?? "12"}
      height={height ?? "13"}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#FD2020"
        fillRule="evenodd"
        d="M.167 6.5A5.836 5.836 0 0 1 6 .665a5.83 5.83 0 0 1 5.833 5.833A5.83 5.83 0 0 1 6 12.333 5.835 5.835 0 0 1 .167 6.499m5.32-2.212c0-.279.233-.513.513-.513s.507.234.507.513v2.579c0 .28-.227.507-.507.507a.51.51 0 0 1-.514-.507zm.519 4.942a.514.514 0 0 1-.514-.514c0-.28.228-.507.508-.507a.51.51 0 0 1 .513.508c0 .28-.227.513-.507.513"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
